export const crumbLabel = {
  "product-line": "Product Lines",
  "product-models": "Models",
  "risk-assessments": "",
  "risk-assessment": "",
  "task-detail": "",
  "device-detail": "",
  "machine-limits": "Limits of Machine",
  "risk-assessment-info": "Assessment Information",
  'assumptions': "Assumptions:",
  'revisionHistory': "Revision History",
  'attendanceRecord': "Attendance record",
  'summary':'Summary'

}

export const crumbHref = {
  "product-line": "/dashboard/assessment/product-line",
  "product-models": "/dashboard/assessment/product-models",
  "risk-assessments": "/dashboard/assessment/risk-assessments",
  "risk-assessment": "/dashboard/assessment/risk-assessment",
  "task-detail": "/dashboard/assessment/task-detail",
  "machine-limits": "/dashboard/assessment/machine-limits",
  "device-detail": "/dashboard/assessment/device-detail"
}

export const currentPath = {
  "product-models": "Models",
  "risk-assessments": ""
}
